import { Feature } from 'geojson';
import { millisecondsInOneDay } from '../shared/constants';
import { convertDecimalToDM } from './location';

export const isValidDateString = (input: string): boolean => {
    const test = new Date(input);
    return !isNaN(test.getTime());
};

export const findIndexOfDateInArray = (dateArray: Date[], queryDate: Date): number => {
    const tempDateDiffs = dateArray.map((d) => Math.abs(queryDate.getTime() - d.getTime())); // Get time difference to all datobjects
    const closestDateIndex = tempDateDiffs.indexOf(Math.min(...tempDateDiffs)); // Get index of smallest timedifference
    return closestDateIndex;
};

export const latLonTextFormat = (lat: number, lon: number): string => {
    const round_lat = Math.round(lat * 100000000) / 100000000;
    const round_lon = Math.round(lon * 100000000) / 100000000;
    return round_lat.toString() + ',' + round_lon.toString();
};

export const formatLatLonText = (selectedFeature: Feature | null): string | null => {
    if (
        selectedFeature &&
        selectedFeature.properties &&
        selectedFeature.properties.lat &&
        selectedFeature.properties.lon
    ) {
        return latLonTextFormat(selectedFeature?.properties?.lat, selectedFeature?.properties?.lon);
    }
    return null;
};
export const formatLatLonDMText = (selectedFeature: Feature | null): string | null => {
    if (
        selectedFeature &&
        selectedFeature.properties &&
        selectedFeature.properties.lat &&
        selectedFeature.properties.lon
    ) {
        const lat = selectedFeature?.properties?.lat;
        const lon = selectedFeature?.properties?.lon;
        return convertDecimalToDM(lat, lon);
    }
    return null;
};

export const isDateIntervalWithinGivenDays = (startDate: Date, endDate: Date, days: number): boolean => {
    return endDate.getTime() - startDate.getTime() < days * millisecondsInOneDay;
};
